import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import './saved-search.scss';
import { useGetCurrentUser } from '../../hooks/auth.ts';
import { SaveSearchResType } from '../../services/api';
import { useNavigate } from 'react-router';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import { useGetFavorites } from '../../api/favorites.ts';
import {
  useDeleteSavedSearch,
  useGetSavedSearches,
  useGetSavedSearchesResults,
} from '../../hooks/saved-search.ts';
import { useTitle } from '../../hooks/useTitle.ts';
import { buildSearchParams } from '../../utils/search.ts';
import { ResultsList } from './components/result-list/result-list.tsx';

export const SavedSearchView = () => {
  useTitle('Saved Searches - Immersive Homes');

  const user = useGetCurrentUser();

  const { data: savedSearches, isPending: loading } = useGetSavedSearches(
    user.data?.userId || ''
  );
  const results = useGetSavedSearchesResults(savedSearches || []);
  const mutation = useDeleteSavedSearch(user.data?.userId || '');

  const { data: favoritesData } = useGetFavorites(user.data?.userId || '');

  const navigate = useNavigate();

  const navigateToSearch = (search: SaveSearchResType) => {
    const { searchName, createdOn, ...newSearch } = search;
    const queryParams = buildSearchParams(newSearch);
    void navigate(`/search?${queryParams}`);
  };

  return (
    <Box data-testid="saved-search-page" className="saved-search-page">
      <Box className="container">
        <Typography variant="h4" className="header" data-home-page-title>
          Saved Searches
        </Typography>
        <Box className="search">
          <Box>
            {!loading &&
              savedSearches &&
              savedSearches.length > 0 &&
              savedSearches.map((search, i: number) => (
                <Box key={search.searchName} className="search-item">
                  <Box
                    sx={{
                      display: 'flex',
                      paddingBottom: '0px',
                      alignItems: 'center',
                      marginBottom: '12px',
                    }}
                  >
                    <Typography
                      sx={{ marginRight: '12px' }}
                      variant="h5"
                      fontWeight="fontWeightMedium"
                    >
                      {search.searchName}
                    </Typography>
                    <IconButton>
                      <EastOutlinedIcon
                        onClick={() => navigateToSearch(savedSearches[i])}
                      />
                    </IconButton>
                    <IconButton>
                      <HighlightOffOutlinedIcon
                        onClick={() =>
                          mutation.mutate(savedSearches[i].searchName || '')
                        }
                      />
                    </IconButton>
                  </Box>
                  <Box>
                    <ResultsList
                      data={results[i].data?.data}
                      favoritesData={favoritesData ?? []}
                    />
                  </Box>
                </Box>
              ))}

            {loading && (
              <Box className="loading-contained">
                <CircularProgress sx={{ marginRight: '12px' }} />
                <Typography>Loading...</Typography>{' '}
              </Box>
            )}

            {!loading && savedSearches && savedSearches.length === 0 && (
              <Box className="no-results">
                <Typography className="no-results-text">
                  No saved searches
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
